import React, { useEffect } from 'react';
import { Container, LinearProgress, Paper, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import moment from 'moment';
import { useNavigate, useParams } from 'react-router-dom';
import { useRecoilState, useSetRecoilState } from 'recoil';

import { driverComplaintState, selectedComplaintState } from '../../atoms/DriverComplaintState';
import ListHeader from '../../components/ListHeader';
import Pagination from '../../components/Pagination';
import { listDriverComplaints } from '../../repositories/HttpRepository';
import Detail from './detail';
import SearchForm from './searchForm';
import useStyles from './styles';
import ShowMore from 'components/ShowMore';

const fields = [
  { id: 'driver_id', numeric: false, disablePadding: true, label: 'Driver ID' },
  {
    id: 'driver_name',
    numeric: false,
    disablePadding: false,
    label: 'Driver Name',
    isDisableSort: true,
  },
  { id: 'id', numeric: false, disablePadding: true, label: 'Complaint ID' },
  {
    id: 'remark',
    numeric: false,
    disablePadding: false,
    label: 'Complaint content',
    isDisableSort: true,
  },
  { id: 'status', numeric: false, disablePadding: false, label: 'Status' },
  {
    id: 'created_ts',
    numeric: false,
    disablePadding: false,
    label: 'Created date',
  },
  { id: 'actions', numeric: false, isDisableSort: true },
];

const DriverComplaintList = () => {
  const [complaints, setComplaints] = useRecoilState(driverComplaintState);
  const setSeleted = useSetRecoilState(selectedComplaintState);
  const { items, page, size, desc, order_by, total, isListing, search_text, complaint_status } = complaints;

  const navigate = useNavigate();
  const { classes } = useStyles();
  let { id } = useParams();

  const getList = (params) => {
    let queryParams = {
      size,
      page,
      search_text,
      complaint_status,
      order_by,
      desc,
    };
    if (params) queryParams = { ...queryParams, ...params };
    listDriverComplaints(queryParams).then((resp) => {
      if (resp.ok) {
        const data = resp.data;
        setComplaints({
          ...complaints,
          items: data.items,
          page: data.page,
          size: data.size,
          total: data.total,
        });
      }
    });
  };

  useEffect(() => {
    getList();
  }, [search_text, complaint_status, order_by, desc, page]);

  const handleChangePage = (event, newPage) => {
    setComplaints({ ...complaints, page: newPage });
  };

  const showDrivers = (e, courierId, courierObj) => {
    e.preventDefault();
  };

  const viewDetailAction = (item) => {
    setSeleted(item);
    setTimeout(() => {
      navigate(`/driver-complaints/${item.id}`);
    }, 100);
  };

  const handleRequestSort = (event, property) => {
    const isDesc = order_by === property && desc;
    setComplaints({
      ...complaints,
      desc: !isDesc,
      order_by: property,
    });
  };

  return (
    <Container maxWidth={false} className={classes.root}>
      <SearchForm initValue={search_text} placeholder="Search for driver ID, driver name, complaint ID, complaint content" />
      <Paper className={classes.paper}>
        <TableContainer>
          <Table className={classes.table} aria-labelledby="tableTitle" aria-label="enhanced table">
            <ListHeader fields={fields} desc={desc} orderBy={order_by} onRequestOrder={handleRequestSort} rowCount={items.length} />
            <TableBody>
              {items &&
                items.map((item, index) => {
                  const labelId = `dsp-table-item-${index}`;
                  return (
                    <TableRow hover tabIndex={-1} key={item.id}>
                      <TableCell component="th" id={labelId} scope="row">
                        {item.driver_id}
                      </TableCell>
                      <TableCell>{item.driver_name}</TableCell>
                      <TableCell id={labelId}>{item.id}</TableCell>
                      <TableCell className={`${classes.content} ${item.new_driver_comment > 0 ? classes.contentBold : ''}`} size="400">
                        <ShowMore text={item.remark} length={130} />
                        {item.new_driver_comment > 0 && <span className={classes.indicator}>{item.new_driver_comment}</span>}
                      </TableCell>
                      <TableCell>{item.status}</TableCell>
                      <TableCell>{moment(item.created_ts).format('DD MMM hh:mm A')}</TableCell>
                      <TableCell>
                        <VisibilityOutlinedIcon style={{ cursor: 'pointer' }} onClick={() => viewDetailAction(item)}></VisibilityOutlinedIcon>
                      </TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
          {isListing && <LinearProgress />}
        </TableContainer>
        <Pagination total={total} size={size} onChange={handleChangePage} forceUpdatePage={page - 1} />
      </Paper>

      {id && <Detail></Detail>}
    </Container>
  );
};
export default React.memo(DriverComplaintList);
